import clothing from './clothing';
import footwear from './footwear';

// const FF_MARKETPLACE_REBRAND = process.env.FF_MARKETPLACE_REBRAND === 'true';

const headermenu = {
  TSS: [
    {
      children: footwear,
      name: 'Footwear',
      path: '/release-dates/'
    },
    {
      name: 'Marketplace',
      slug: 'sole-market'
    },
    {
      children: clothing,
      name: 'Clothing',
      path: '/clothing/'
    },
    {
      name: 'Sale',
      slug: 'sale/'
    },
    {
      name: 'News',
      slug: 'news/'
    }
  ]
};

export default headermenu;
